import service from '@/services/cliente/cliente'
import serviceFactura from '@/services/facturacion/factura'
import { Session } from '@/plugins/session'
const ObjectID = require('bson-objectid')

const getDefaultState = () => ({
  cliente: {
    nombre: '',
    identificacion: { tipo: { id: '' }, numero: null },
    identificacionExtranjero: '',
    nombreComercial: '',
    categoria: {
      _id: '',
      detalle: ''
    },
    ubicacion: {
      provincia: { id: '' },
      canton: { id: '' },
      distrito: { id: '' },
      otrasSenas: ''
    },
    telefono: { codigoPais: 506, numTelefono: null },
    correoElectronico: '',
    correoElectronicoContacto: '',
    genero: null,
    // fechaNacimiento: null,
    ref: '',
    accion: [],
    subscriptions: [],
    ciclo: 'Oportunidad',
    cicloHistorico: [],

    ventas: {
      facturas: [],
      items: []
    },

    ejecutivo: { _id: null },

    balanceTotal: 0,

    // conta
    cuentaContable: null,
    plazoCredito: null,
    limiteCredito: 0,
    limiteCreditoBlock: false,
    codigoActividadReceptor: null
  },

  fullListLoaded: false,
  list: [],
  listVentas: [],
  birthdayList: [],
  autoPayTransactions: [],
  currentRow: null,
  accion: {
    tipo: '',
    // usuario: '',
    prodServ: '',
    detalle: '',
    fecha: ''
  },
  pageInfo: {},
  saved: 'null',
  balanceAccount: 0,
  balanceAccountDate: 0,
  totalRegistros: 0,

  selectedPaymentMethodId: null // usado en link de pago, y posiblemente en marketplace.
})

export const state = () => getDefaultState()

export const mutations = {
  RESET_STATE: state => Object.assign(state, getDefaultState()),
  SET_ROW: (state, row) => (state.currentRow = row),
  SET_CLIENTES: (state, obj) => {
    state.list = [...new Set([...state.list.map(JSON.stringify), ...obj.feed.map(JSON.stringify)])].map(JSON.parse)
    state.pageInfo = obj.pageInfo
  },
  SET_CLIENTE: (state, obj) => {
    let waTelefonos = null
    if (obj.waTelefonos) {
      waTelefonos = obj.waTelefonos.join(',')
    }
    state.cliente = { ...state.cliente, ...obj, ...(waTelefonos && { waTelefonos }) }
    state.saved = true
  },
  SET_CLIENTES_VENTAS: (state, objs) => {
    state.listVentas = objs
  },
  RESET_CLIENTES_VENTAS: state => {
    state.listVentas = []
  },
  UPDATE_LIST: (state, obj) => {
    const nObj = state.list.find(e => e._id === obj._id)
    if (!nObj) state.list = [obj, ...state.list]
    else Object.keys(nObj).forEach(i => (nObj[i] = obj[i]))
    state.saved = true
  },
  ADD_ACCION: (state, obj) => {
    const nObj = state.cliente.accion.find(e => e._id === obj._id)

    if (!nObj) {
      obj._id = new ObjectID()

      state.cliente.accion = [obj, ...state.cliente.accion]
    } else Object.keys(nObj).forEach(i => (nObj[i] = obj[i]))

    state.saved = false
  },
  SET_ACCION: (state, obj) => {
    const acc = state.cliente.accion.find(e => e._id === obj._id)

    state.accion = acc
  },
  // RESETEA los arreglos de reportes facturas del cliente (tab de ventas)
  RESET_VENTAS_CLIENTE: state => {
    state.cliente.ventas.facturas = []
    state.cliente.ventas.items = []
  },

  SET_VENTAS_CLIENTE: (state, obj) => {
    state.cliente.ventas.facturas = obj.facturas
    state.cliente.ventas.items = obj.itemGroup
    // if (state.cliente.ventas) {
    //   state.cliente.ventas.facturas = obj.facturas
    //   state.cliente.ventas.items = obj.itemGroup
    // } else
    //   state.cliente.ventas = {
    //     facturas: obj.facturas,
    //     items: obj.itemGroup
    //   }
  },

  RESET: (state, { identificacionDef }) => {
    state.cliente = { ...getDefaultState().cliente, identificacion: { tipo: { id: identificacionDef }, numero: '' } }
  },

  RESET_ACCION: state => {
    state.accion = { ...getDefaultState().accion }
  },
  DELETE_LIST: (state, obj) => {
    state.list = state.list.filter(e => e._id !== obj._id)
  },
  DELETE_ACCION: (state, obj) => {
    obj.forEach(i => {
      state.cliente.accion = state.cliente.accion.filter(e => e._id !== i)
    })
  },
  SAVE_CHANGES: (state, obj) => {
    state.cliente = obj
    state.saved = false
  },
  SAVE_CHANGES_ACCION: (state, obj) => {
    state.accion = obj
  },
  SET_BALANCE_ACCOUNT: (state, obj) => {
    state.balanceAccount = obj
  },
  SET_BALANCE_ACCOUNT_DATE: (state, obj) => {
    state.balanceAccountDate = obj
  },
  SET_SELECTED_PAYMENT_METHOD_ID: (state, obj) => {
    state.selectedPaymentMethodId = obj
  },
  SET_FULL_LIST_LOADED: (state, val) => {
    state.fullListLoaded = val
  },
  SET_AUTO_PAY_TRANSACTIONS: (state, obj) => {
    state.autoPayTransactions = obj
  },
  SET_BIRTHDAY_LIST: (state, obj) => {
    state.birthdayList = obj
  },
  SET_ACCOUNT: (state, obj) => {
    state.cliente.cuentaContable = obj
  }
}
export const actions = {
  readBirthday: async ({ commit, state, rootGetters, dispatch }) => {
    // if (restart) await dispatch('resetList')

    // if (state.list.length > 0) {
    //   return true
    // }

    return service.readBirthday(rootGetters['facturacion/emisorStore/get_Id']).then(response => commit('SET_BIRTHDAY_LIST', response))
  },
  readBySearchString: async ({ rootGetters }, { searchString, ejecutivo }) =>
    service.readBySearchString(rootGetters['facturacion/emisorStore/get_Id'], searchString, ejecutivo),
  resetList: ({ state }) => {
    state.list = []
    state.pageInfo = {}
  },
  readAllByEmisor: async ({ commit, state, rootGetters, dispatch }, { restart = false, limit = 10, filter = null }) => {
    if (restart) await dispatch('resetList')

    return service.readAllByEmisor(rootGetters['facturacion/emisorStore/get_Id'], state.pageInfo.nextPageCursor, limit, filter).then(response => {
      console.log('Clientes from db 🫠')
      return commit('SET_CLIENTES', response)
    })
  },

  async readTotalRegistros({ commit, state, rootGetters }, ejecutivo) {
    return service.readTotalRegistros(rootGetters['facturacion/emisorStore/get_Id'], ejecutivo).then(response => {
      state.totalRegistros = response
    })
  },

  readAllByIds: async ({ commit }, { _ids }) => {
    return service.readAllByIds(_ids.map(i => i.receptor.id)).then(response => {
      // agrupa transacciones por cliente sin sumar los que tienen NC
      const tr = _ids.reduce((acc, item) => {
        if (!item.notaCredito.length) {
          const receptor = acc.find(a => a._id === item.receptor.id)
          if (!receptor) {
            acc.push({
              _id: item.receptor.id,
              totalVentaNeta: item.resumenFactura.totalComprobante,
              transacciones: 1
            })
          } else {
            receptor.totalVentaNeta += item.resumenFactura.totalComprobante
            receptor.transacciones += 1
          }
        }

        return acc
      }, [])

      const data = response.map(r => {
        const cliente = tr.find(t => t._id === r._id)

        return {
          ...r,
          totalVentaNeta: cliente.totalVentaNeta,
          transacciones: cliente.transacciones
        }
      })

      commit('SET_CLIENTES_VENTAS', data)
    })
  },

  readById: async ({ state, commit }, { _id, refresh = false }) => {
    return service.readById(_id).then(response => {
      if (!response.telefono) response.telefono = { codigoPais: 506, numTelefono: null }
      if (!response.identificacion) response.identificacion = { tipo: { id: '' }, numero: null }
      if (!response.ubicacion)
        response.ubicacion = {
          provincia: { id: '' },
          canton: { id: '' },
          distrito: { id: '' },
          otrasSenas: ''
        }
      if (!response.categoria) response.categoria = { _id: '', detalle: '' }
      if (!response.ejecutivo) response.ejecutivo = { _id: null }

      commit('SET_CLIENTE', response)

      return response
    })
  },

  readByEmail: async ({}, { emisor, email }) => {
    return service.readByEmail(emisor, email).then(response => {
      if (!response) return

      if (!response.telefono) response.telefono = { codigoPais: 506, numTelefono: null }
      if (!response.identificacion) response.identificacion = { tipo: { id: '' }, numero: null }
      if (!response.ubicacion)
        response.ubicacion = {
          provincia: { id: '' },
          canton: { id: '' },
          distrito: { id: '' },
          otrasSenas: ''
        }

      return response
    })
  },

  readByFactura: async ({ state, commit }, { _id, refresh = false }) => {
    return service.readByFactura(_id).then(response => {
      commit('SET_CLIENTE', response)

      return response
    })
  },

  create: async ({ state, commit, rootGetters }, { input }) => {
    let cliente = {}
    Object.entries(input).forEach(entry => {
      const key = entry[0]
      const value = entry[1]

      if (key === 'identificacion' && !value.numero) return false
      if (key === 'ubicacion' && !value.provincia.id) return false
      if (key === 'telefono' && !value.numTelefono) return false
      if (key === 'categoria' && !value._id) return false
      if (key === 'limiteCredito') {
        cliente[key] = Number(value || 0)
        return
      }

      cliente[key] = value
    })

    delete cliente.loaded
    delete cliente.createdAt
    delete cliente.updatedAt
    delete cliente.cicloHistorico
    delete cliente.ventas
    delete cliente.subscriptions
    delete cliente.balanceTotal
    // delete cliente.ejecutivo

    if (cliente.plazoCredito === '') cliente.plazoCredito = 0

    return service
      .create({
        ...cliente,

        username: Session.user.fullname,

        emisor: {
          _id: await rootGetters['facturacion/emisorStore/get_Id']
        },
        ...(cliente.plazoCredito && { plazoCredito: Number(cliente.plazoCredito) })
      })
      .then(async result => {
        // evita la actualización de la lista. En este caso me dio pereza hacer el commit de saved = true
        if (state.searchedDB) return (state.saved = true)

        commit('UPDATE_LIST', {
          ...result,
          ...(cliente.categoria && {
            categoria: { ...cliente.categoria, ...rootGetters['cliente/categoriaStore/get'](cliente.categoria._id) }
          })
        })

        commit('SET_CLIENTE', { _id: result._id })

        return result
      })
  },

  delete: ({ commit }, { clientes }) =>
    service.delete(clientes).then(result => {
      result.forEach(i => {
        if (i.state) commit('DELETE_LIST', i)
      })
      return result
    }),

  setCiclo: async ({ commit }, { receptor, ciclo = 'Conversion', detalle }) => {
    if (!receptor._id) return false

    return service.setCiclo(receptor._id, ciclo, detalle).then(result => {
      if (result) commit('UPDATE_LIST', { ...receptor, ciclo })
      return result
    })
  },

  statsCiclo: async ({ rootGetters }) => service.statsCiclo(await rootGetters['facturacion/emisorStore/get_Id']),
  statsAnnCiclo: async ({ rootGetters }) => service.statsAnnCiclo(await rootGetters['facturacion/emisorStore/get_Id']),
  ventasCliente: async ({ commit, rootGetters }, { _id, showNC }) => {
    return serviceFactura.ventasCliente(await rootGetters['facturacion/emisorStore/get_Id'], _id, showNC).then(result => commit('SET_VENTAS_CLIENTE', result))
  },
  setBalance: async ({}, { _id, monto, type, detalle, _idPago }) => {
    return service.setBalance(_id, monto, type, detalle, _idPago)
  },
  getBalanceTotal: async ({ state }, { _id }) =>
    service.getBalanceTotal(_id).then(result => {
      // TODO: deberia de actualizar la lista de clientes y retornar de caché
      state.cliente.balanceTotal = result
    }),
  getBalance: async ({}, { _id }) => service.getBalance(_id),
  getBalancesByDate: async ({ rootGetters }, { start, end }) => service.getBalancesByDate(await rootGetters['facturacion/emisorStore/get_Id'], start, end),
  getBalanceAccount: async ({ commit, rootGetters }) =>
    service.getBalanceAccount(await rootGetters['facturacion/emisorStore/get_Id']).then(result => {
      commit('SET_BALANCE_ACCOUNT', result)
    }),
  getBalanceAccountByDate: async ({ commit, rootGetters }, { start, end }) =>
    service.getBalanceAccountByDate(await rootGetters['facturacion/emisorStore/get_Id'], start, end).then(result => {
      commit('SET_BALANCE_ACCOUNT_DATE', result)
    }),

  readByIdPaymentLink: async ({ commit }, { _id }) => {
    return service.readByIdPaymentLink(_id).then(response => {
      commit('SET_CLIENTE', response)

      return response
    })
  },

  async createMethod({ state }, { customerId, card, secret, _idEmisor }) {
    try {
      const response = await fetch(`${process.env.NUXT_ENV_PAYMENT}/metodos/create`, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${Session.token}`
        },
        body: JSON.stringify({
          customerId,
          type: 'card',
          publicSecretKey: secret,
          card: {
            number: card.creditCardNumber,
            expMonth: Number(card.expMonth),
            expYear: Number(card.expYear),
            cvv: card.creditCardSecurityCodeNumber.toString(),
            holderName: card.cardName
          }
        })
      }).then(res => res.json())

      if (response.status >= 400) {
        console.error('ERROR 💥', response)

        return { status: false }
      }

      console.log('Metodo de pago agregado, paymentMethodId: ', response)

      const last4 = card.creditCardNumber.toString().slice(-4)

      state.cliente.paymentMethods = [
        ...state.cliente.paymentMethods,
        {
          paymentMethodId: response.id,
          last4
        }
      ]

      state.selectedPaymentMethodId = response.id

      service
        .eCommerceCreate({
          input: {
            _id: state.cliente._id,
            emisor: { _id: _idEmisor },
            nombre: state.cliente.nombre,
            correoElectronicoContacto: state.cliente.correoElectronicoContacto,
            correoElectronico: state.cliente.correoElectronico,
            ciclo: 'Conversion',
            customerId: state.cliente.customerId,
            paymentMethods: state.cliente.paymentMethods
          }
        })
        .then(async result => {
          return result
        })

      return { status: true, response }
    } catch (error) {
      console.error('ERROR FATAL 💥💥💥', error)

      return { status: false }
    }
  },

  createOnvoClient: async ({ state }, { card, secret, _idEmisor }) => {
    try {
      const email = state.cliente.correoElectronico.split(',')[0]

      const response = await fetch(`${process.env.NUXT_ENV_PAYMENT}/clientes/create`, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${Session.token}`
        },

        body: JSON.stringify({
          name: state.cliente.nombre.normalize('NFD').replace(/[\u0300-\u036f]/g, ''),
          email,
          type: 'card',
          publicSecretKey: secret,
          card: {
            number: card.creditCardNumber,
            expMonth: Number(card.expMonth),
            expYear: Number(card.expYear),
            cvv: card.creditCardSecurityCodeNumber.toString(),
            holderName: card.cardName
          }
        })
      }).then(res => res.json())

      if (response.status >= 400) {
        console.error('ERROR 💥', response)

        return { status: false }
      }

      const last4 = card.creditCardNumber.toString().slice(-4)

      state.cliente.customerId = response.customerId
      state.cliente.paymentMethods = [
        {
          paymentMethodId: response.paymentMethodId,
          last4
        }
      ]

      // guarda el customerId y paymentMethodId del cliente
      state.selectedPaymentMethodId = response.paymentMethodId

      service
        .eCommerceCreate({
          input: {
            _id: state.cliente._id,
            emisor: { _id: _idEmisor },
            nombre: state.cliente.nombre,
            correoElectronicoContacto: state.cliente.correoElectronicoContacto,
            correoElectronico: state.cliente.correoElectronico,
            ciclo: 'Conversion',
            customerId: state.cliente.customerId,
            paymentMethods: state.cliente.paymentMethods
          }
        })
        .then(async result => {
          console.log('result ecommerce create vuex :>> ', result)
          return result
        })

      return { status: true, response }
    } catch (error) {
      console.error('ERROR FATAL al crear el cliente ONVO 💥💥💥', error)

      return { status: false }
    }
  },

  sendTransaction: async ({ state }, { currency, amount, description, secret }) => {
    try {
      const response = await fetch(`${process.env.NUXT_ENV_PAYMENT}/payment/intent`, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${Session.token}`
        },
        body: JSON.stringify({
          customerId: state.cliente.customerId,
          paymentMethodId: state.selectedPaymentMethodId,

          amount, // el monto se envia sin punto decimal y con dos ceros a la derecha
          currency,
          description,

          publicSecretKey: secret
        })
      }).then(res => res.json())

      console.log('Onvo response :>> ', response)

      if (response.status === 'succeeded') {
        return { status: true }
      }

      console.error('ERROR 💥', response)

      if (response?.lastPaymentError) {
        console.log('response?.lastPaymentError :>> ', response?.lastPaymentError)
        return { status: false, error: response?.lastPaymentError }
      } else return { status: false, error: null }
    } catch (error) {
      console.error('ERROR FATAL al enviar la transacción ONVO 💥💥💥', error)

      return { status: false }
    }
  },

  setEjecutivo: ({}, { _id, ejecutivo }) =>
    service.setEjecutivo(_id, ejecutivo).then(result => {
      console.log('result :>> ', result)
      return result
    }),

  readAutoPayTransactions: ({ commit, rootGetters }) =>
    service.readAutoPayTransactions(rootGetters['facturacion/emisorStore/get_Id']).then(response => {
      commit('SET_AUTO_PAY_TRANSACTIONS', response)
    }),
  saveCodigoActividadReceptor: ({}, { _id, codigoActividadReceptor }) => service.saveCodigoActividadReceptor(_id, codigoActividadReceptor),
  setCuentaContable: ({}, { _id, cuentaContable }) => service.setCuentaContable(_id, cuentaContable),

  healthCheck: () => service.healthCheck()
}
